import React from "react";
import './Service.css';
import { Link } from "react-router-dom";

function Service() {
    const navigateTo = (route) => {
        window.location.href = route;
    };
    return (
        <div className="service component__space" id="Services">
            <div className="heading">
                <h1 className="heading">Services</h1>
                <p className="heading p__color">
                    We provide our best to You.
                </p>
                <p className="heading p__color">
                    We Work for Your Dream
                </p>
            </div>

            <div className="container">
                <div className="service__box pointer" onClick={() => navigateTo("/architect")}>
                <div className="logoss">
                <img src="images/logos/architecture.png" alt="k" />
                </div>
                        <h1 className="service__text">Architecture</h1>
                    
                </div>

                
                <div className="service__box pointer" >
                <div className="logoss">
                <img src="images/logos/BOQ.png" alt="k" />
                </div>
                        <h1 className="service__text">BOQ/Estimate</h1> 
                 
                </div>

                
                <div className="service__box pointer" onClick={() => navigateTo("/construction")}>
                <div className="logoss">
                        <img src="images/logos/construction.png" alt="k" />
                        </div>
                        <h1 className="service__text">Construction</h1>
                    
                </div>

                
                <div className="service__box pointer">
                <div className="logoss">
                <img src="images/logos/waterproof.png" alt="k" />
                   </div>
                    
                        <h1 className="service__text">Water Proofing</h1>
                        {/* <p className="p service__text p__color">
                            Our waterproofing solutions protect your structures from water damage, ensuring longevity and durability. We use advanced materials and techniques to prevent leaks and seepage, safeguarding your investment from the elements.
                        </p>*/}
                   
                </div>
            
                <div className="service__box pointer" onClick={() => navigateTo("/slab")}>
                    <div className="logoss">
                <img src="images/logos/const.png" alt="k" />
                </div>
                        <h1 className="service__text">SLAB</h1>      
                      
                </div>
                
                <div className="service__box pointer">
                <div className="logoss">
                <img src="images/logos/aluminium.png" alt="k" />
                </div>
                        <h1 className="service__text">Aluminium Work</h1>
                   
                </div>
            </div>
        </div>    
    );
}

export default Service;
